import { useEffect } from 'react';
import { getSocket } from '../services/socketService';
import { useToast } from './useToast';

export interface EarningsReminderEvent {
  assetId: string;
  ticker: string;
  name: string;
  earningsDate: string;
  daysBefore: number;
  daysUntil: number;
  message: string;
}

/**
 * Surface the backend's earnings-reminder events (T-10 / T-3 countdowns) as
 * toasts. The server emits `earnings_reminder` into the user's own room; this
 * mounts once in the authed shell so a covering analyst (and their manager)
 * see the reminder wherever they are in the app. Fire-and-forget: a missed
 * event just means no toast — the calendar view remains the source of truth.
 */
export function useEarningsReminders(): void {
  const toast = useToast();

  useEffect(() => {
    const socket = getSocket();
    if (!socket.connected) socket.connect();

    const handler = (payload: EarningsReminderEvent) => {
      toast.info(payload?.message || 'Upcoming earnings reminder', 8000);
    };
    socket.on('earnings_reminder', handler);

    return () => {
      socket.off('earnings_reminder', handler);
    };
  }, [toast]);
}

export default useEarningsReminders;
